import(/* webpackMode: "eager" */ "/vercel/path0/src/app/get-started/page.tsx")